import { ImageInput } from 'react-admin';

const ImageInputA = (props: any) => (
  <ImageInput data-testid={props.label} {...props} />
);

export default ImageInputA;
